import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import type React from 'react';

const FIELD_HEIGHT = 56;
// Full rendered min height of EmailTemplateRichTextEditor: border(1) + toolbar(40) + border(1) + content padding(32) + tiptap min(240)
const BODY_HEIGHT = 314;
const SEND_BUTTON_HEIGHT = 36;
const SEND_BUTTON_WIDTH = 100;

type SlotProps = { isLoading: true; children?: never } | { isLoading?: false; children: React.ReactNode };

type RootProps = { isLoading: true; children?: never } | { isLoading?: false; children: React.ReactNode };

// Body wraps both the skeleton and the real editor in the same sized container —
// BODY_HEIGHT is the single source of truth for both states.
const Body = (props: SlotProps) => (
  <Box sx={{ height: BODY_HEIGHT }}>{props.isLoading ? <Skeleton variant="rounded" width="100%" height="100%" /> : props.children}</Box>
);

const Root = (props: RootProps) => {
  if (props.isLoading) {
    return (
      <Stack spacing={2} data-testid="email-form-skeleton">
        <Skeleton variant="rounded" height={FIELD_HEIGHT} />
        <Skeleton variant="rounded" height={FIELD_HEIGHT} />
        <Skeleton variant="rounded" height={FIELD_HEIGHT} />
        <Body isLoading />
        <Stack direction="row" justifyContent="flex-end">
          <Skeleton variant="rounded" height={SEND_BUTTON_HEIGHT} width={SEND_BUTTON_WIDTH} sx={{ borderRadius: '18px' }} />
        </Stack>
      </Stack>
    );
  }
  return <Stack spacing={2}>{props.children}</Stack>;
};

const Actions = ({ children }: { children: React.ReactNode }) => (
  <Stack direction="row" justifyContent="flex-end">
    {children}
  </Stack>
);

export const EmailFormLayout = { Root, Body, Actions };
